import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Skeleton from '@material-ui/lab/Skeleton'
import useStyles from '../styles'

const StatCard = ({ label, value, caption, loading, error }) => {
  const classes = useStyles()

  return (
    <Box className={classes.statCard}>
      <Box className={classes.statHeader}>
        <Typography className={classes.statLabel}>{label}</Typography>
      </Box>
      {loading ? (
        <Skeleton
          variant="rect"
          width={96}
          height={21}
          className={classes.statSkeleton}
        />
      ) : error ? (
        <Typography className={`${classes.statLabel} ${classes.messageError}`}>
          Unable to load
        </Typography>
      ) : (
        <Typography className={classes.statValue}>{value}</Typography>
      )}
      {caption ? (
        <Typography className={classes.statCaption}>{caption}</Typography>
      ) : null}
    </Box>
  )
}

export default StatCard
